import { render } from "./Ornograma.vue?vue&type=template&id=77aaf541&scoped=true"
import script from "./Ornograma.vue?vue&type=script&lang=js"
export * from "./Ornograma.vue?vue&type=script&lang=js"

import "./Ornograma.vue?vue&type=style&index=0&id=77aaf541&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77aaf541"]])

export default __exports__